export const getGroupName = () => {

  if (process.env.DEBUG_GROUP_NAME) {
    return process.env.DEBUG_GROUP_NAME;

  } else {

    return window.location.hostname.slice(
      0,
      window.location.hostname.indexOf(".", 0)
    );
    
  }
};
